import { StepConfig, StepperConfig } from '@mydocma/import-export';

export const step1: StepConfig = {
  name: 'selectTemplate',
  label: 'MM.report.tabs.template.title',
  icon: {
    number: '_send-letter',
    edit: '_send-letter',
    done: '_send-letter'
  },
  optional: false,
  editable: true,
  enabled: true
};

export const step2: StepConfig = {
  name: 'selectOptions',
  label: 'MM.reporting.writing.tabs.options',
  icon: {
    number: 'toggle_off',
    edit: 'toggle_off',
    done: 'toggle_off'
  },
  optional: false,
  editable: true,
  enabled: true
};


export const step3: StepConfig = {
  name: 'selectCreationType',
  label: 'MM.reporting.writing.tabs.creating',
  icon: {
    number: 'done',
    edit: 'done',
    done: 'done'
  },
  optional: false,
  editable: true,
  enabled: true
};

export const step4: StepConfig = {
  name: 'selectEmail',
  label: 'MM.reporting.writing.tabs.email',
  icon: {
    number: 'mail',
    edit: 'mail',
    done: 'mail'
  },
  optional: false,
  editable: true,
  enabled: true
};


export const reportStepperConfig: StepperConfig = {
  steps: [
    step1,
    step2,
    step3,
    step4
  ]
}
